import React from 'react';

const loader = () => (
  <div>
    Loading...
  </div>
)

export default loader;